import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { FundingService } from "./FundingService";

export const FundingCustomers = createAsyncThunk(
    "ls/GetSuperdealerResellerProducts",
    async (payload, { rejectWithValue, getState, dispatch }) => {
      try {
        const response = await FundingService.FundingModule().FundingCustomers(
            payload
        );
        return response?.data;
      } catch (error) {
        toast.error(error?.response?.data?.message);
        //  exitReponse(error);
        return error?.response;
      }
    }
);

// GetBanks
export const GetBanks = createAsyncThunk(
    "ls/GetSuperdealerResellerProducts",
    async (payload, { rejectWithValue, getState, dispatch }) => {
      try {
        const response = await FundingService.FundingModule().GetBanks(payload);
        return response?.data;
      } catch (error) {
        toast.error(error?.response?.data?.message);
        //  exitReponse(error);
        return error?.response;
      }
    }
);

export const ViewAllWallet = createAsyncThunk(
    "ls/GetSuperdealerResellerProducts",
    async (payload, { rejectWithValue, getState, dispatch }) => {
      try {
        const response = await FundingService.FundingModule().ViewAllWallet(
            payload
        );
        return response?.data;
      } catch (error) {
        toast.error(error?.response?.data?.message);
        //  exitReponse(error);
        return error?.response;
      }
    }
);

export const TransferToBank = createAsyncThunk(
    "ls/TransferToBanks",
    async (payload, { rejectWithValue, getState, dispatch }) => {
      try {
        const response = await FundingService.FundingModule().TransferToBank(
            payload
        );
        toast.success("Transaction Successful");
        return response?.data;
      } catch (error) {
        toast.error(error?.response?.data?.message);
        return rejectWithValue(error?.response?.data);
      }
    }
);

export const FundingSlice = createSlice({
  name: "Users",
  initialState: "",
  reducers: {
    resetTransferToBank: (state) => {
      return {
        ...state,
        TransferToBankSuccess: undefined,
        error: undefined,
      };
    },
  },
  extraReducers: {
    [GetBanks.pending]: (state, action) => {
      state.loading = true;
    },

    [GetBanks.fulfilled]: (state, action) => {
      return {
        ...state,
        GetBanksSuccess: action.payload,
        loading: false,
      };
    },

    [GetBanks.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        GetBanksError: action.payload,
      };
    },

    [ViewAllWallet.pending]: (state, action) => {
      state.loading = true;
    },

    [ViewAllWallet.fulfilled]: (state, action) => {
      return {
        ...state,
        ViewAllWalletSuccess: action.payload,
        loading: false,
      };
    },

    [ViewAllWallet.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        ViewAllWalletError:
            action.payload?.response?.data?.message || action.payload,
      };
    },

    // ***********************************************************************************************************************************************************************************************

    [FundingCustomers.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [FundingCustomers.fulfilled]: (state, action) => {
      return {
        ...state,
        FundingCustomersSuccess: action.payload,
        loading: false,
      };
    },
    [FundingCustomers.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [TransferToBank.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [TransferToBank.fulfilled]: (state, action) => {
      return {
        ...state,
        TransferToBankSuccess: action.payload,
        loading: false,
      };
    },
    [TransferToBank.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },
  },
});

export const { resetTransferToBank } = FundingSlice.actions;

export default FundingSlice.reducer;
